<template>
  <!-- z-index 300 to cater for safari bug -->
  <v-autocomplete
    :label="label"
    v-model="selected"
    @input="handleInput"
    @change="handleInput"
    @focus="immediate && search()"
    :color="themes.candidate.light.input"
    :disabled="disabled"
    :hint="hint"
    :items="options"
    :loading="loading"
    :placeholder="searchTerm"
    :required="required"
    :rules="rules || []"
    :search-input.sync="searchTerm"
    item-value="id"
    :style="toFront ? 'z-index: 300' : ''"
    hide-no-data
    no-filter
    return-object
    clearable
    attach
  >
    <template slot="item" slot-scope="{ item: qualification }">
      <v-list-tile-avatar v-if="qualification.institution">
        <img
          :src="qualification.institution.logo || '/img/missing/logos/institutions/original.png'"
        />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-if="qualification.display">{{
          qualification.display
        }}</v-list-tile-title>
        <v-list-tile-sub-title v-if="qualification.institution">
          <span v-if="qualification.institution.name">{{ qualification.institution.name }}</span>
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
    <template slot="selection" slot-scope="{ item: qualification }">
      <slot name="selection" v-bind:qualification="qualification">
        <v-chip>
          <v-avatar v-if="qualification.institution">
            <img
              :src="
                qualification.institution.logo || '/img/missing/logos/institutions/original.png'
              "
            />
          </v-avatar>
          {{ qualification.display }}
        </v-chip>
      </slot>
    </template>
    <template slot="append-item">
      <v-btn
        @click="sendCrispMessage('I would like to add a qualification to your database')"
        :color="themes.candidate.light.primaryActionButton"
      >
        <v-icon left>mdi-help-circle</v-icon>
        Help, I cannot find my qualification
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<script>
// Helpers
import _ from 'lodash'
import { mapGetters } from 'vuex'

// Vue Component
export default {
  props: {
    categories: Array,
    institutions: Array,
    disabled: Boolean,
    hint: { type: String, default: () => 'Start typing qualification or study programme name' },
    label: { type: String, default: () => 'Qualification or study programme' },
    required: Boolean,
    rules: Array,
    toFront: { type: Boolean, default: () => true },
    immediate: { type: Boolean, default: () => false },
    value: [Object, Number],
  },

  created() {
    this.setSelected()
  },

  data() {
    return {
      selected: {},
      loading: false,
      searchTerm: '',
      qualifications: [],
    }
  },

  computed: {
    options() {
      if (this.selected && this.selected.id) return [this.selected, ...this.qualifications]
      return this.qualifications.length ? this.qualifications : []
    },
  },

  watch: {
    value: function() {
      this.setSelected()
    },
    searchTerm: _.debounce(function(search) {
      this.$emit('search', search)
      // search is null on initial load
      if (search && search.length > 0) {
        this.search()
      } else {
        this.qualifications = []
      }
    }, 300),
  },

  methods: {
    handleInput(qualification) {
      this.selected = _.get(qualification, 'id') ? qualification : {}
      this.$emit('input', this.selected)
    },

    search() {
      this.loading = true
      let params = { search: this.searchTerm }
      if (this.categories && this.categories[0]) params['categories'] = this.categories
      if (this.institutions && this.institutions[0]) {
        params['institution_ids'] = this.institutions.map(i => i.id)
      }

      this.$http
        .get('search/qualifications', { params })
        .then(response => {
          this.qualifications = response.data
        })
        .catch(error => {
          // console.log(error)
        })
        .finally(() => (this.loading = false))
    },

    sendCrispMessage(message) {
      if (!window.CRISP_READY || !message || !message.length) return
      $crisp.push(["do", "chat:open"])
      $crisp.push(["do", "message:send", ["text", message]])
    },

    setSelected() {
      if (_.get(this.value, 'display')) {
        this.searchTerm = this.value.display
        this.selected = JSON.parse(JSON.stringify(this.value))
        this.search()
      }
    },
  },
}
</script>
